import type { ColorName } from 'styles/config/colors';

/**
 * Convert a camelCase ColorName to its CSS custom property value.
 *
 * Every ColorName has a corresponding `--tw-{kebab-case}` CSS variable
 * defined in `styles/tailwind.css` (both :root and .dark).
 *
 * @example
 *   colorCssVar('textPrimary')      // 'var(--tw-text-primary)'
 *   colorCssVar('backgroundBrand')  // 'var(--tw-background-brand)'
 *   colorCssVar('iconDanger')       // 'var(--tw-icon-danger)'
 */
function toKebab(name: string): string {
  return name
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2') // DTMFNode → DTMF-Node
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2') // textPrimary → text-Primary
    .replace(/([a-z])(\d)/g, '$1-$2') // errorText01 → errorText-01
    .toLowerCase();
}

export function colorCssVar(name: ColorName): string {
  return `var(--tw-${toKebab(name)})`;
}
